/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer__Auctions__Item_3Inputs */

const en_footer__auctions__item_3 = /** @type {(inputs: Footer__Auctions__Item_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current battles`)
};

/**
* | output |
* | --- |
* | "Current battles" |
*
* @param {Footer__Auctions__Item_3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const footer__auctions__item_3 = /** @type {((inputs?: Footer__Auctions__Item_3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer__Auctions__Item_3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_footer__auctions__item_3(inputs)
});